// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__4-rB2","colMin":"styles_colMin__3pibJ"};